/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AppHolder_manager = {
    readonly uuid: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly profileImageUrl: string | null;
    readonly hasComplianceAccess: boolean;
    readonly company: {
        readonly logoURL: string | null;
        readonly name: string;
        readonly securityProgrammes: {
            readonly pageInfo: {
                readonly total: number;
            };
        } | null;
        readonly machineReports: {
            readonly pageInfo: {
                readonly total: number;
            };
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"CompanyModal_company">;
    };
    readonly " $fragmentRefs": FragmentRefs<"ManagerModal_manager" | "HeaderMenu_manager">;
    readonly " $refType": "AppHolder_manager";
};
export type AppHolder_manager$data = AppHolder_manager;
export type AppHolder_manager$key = {
    readonly " $data"?: AppHolder_manager$data;
    readonly " $fragmentRefs": FragmentRefs<"AppHolder_manager">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "Literal",
        "name": "page",
        "value": {
            "limit": 0,
            "offset": 0
        }
    } as any), v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "total",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "AppHolder_manager",
        "type": "Manager",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "uuid",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "profileImageUrl",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasComplianceAccess",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "company",
                "storageKey": null,
                "args": null,
                "concreteType": "Company",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "logoURL",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "securityProgrammes",
                        "storageKey": "securityProgrammes(page:{\"limit\":0,\"offset\":0})",
                        "args": [
                            (v0 /*: any*/)
                        ],
                        "concreteType": "SecurityProgrammePage",
                        "plural": false,
                        "selections": (v1 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "machineReports",
                        "storageKey": "machineReports(filter:{\"sent\":true},page:{\"limit\":0,\"offset\":0})",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                    "sent": true
                                }
                            },
                            (v0 /*: any*/)
                        ],
                        "concreteType": "MachineReportPage",
                        "plural": false,
                        "selections": (v1 /*: any*/)
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "CompanyModal_company",
                        "args": null
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "ManagerModal_manager",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "HeaderMenu_manager",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = '65607179c9b476e4edc9d09f9c6fd635';
export default node;
